export const iconFontAwesomeMoneyTurkishLiraSign = (
	<i className="fa-solid fa-turkish-lira-sign"></i>
);
